import React from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { usePermissions } from '../../../../contexts/PermissionsContext';
import StudentLMSLayout from './StudentLMSLayout';
import TeacherLMSLayout from './TeacherLMSLayout';
import DesignerLMSLayout from './DesignerLMSLayout';
import ManagerLMSLayout from './ManagerLMSLayout';
import AdminLMSLayout from './AdminLMSLayout';
import SuperAdminLMSLayout from './SuperAdminLMSLayout';
import StudentLMSMain from './StudentLMSMain';
import TeacherLMSMain from './TeacherLMSMain';
import DesignerLMSMain from './DesignerLMSMain';
import ManagerLMSMain from './ManagerLMSMain';
import AdminLMSMain from './AdminLMSMain';
import SuperAdminLMSMain from './SuperAdminLMSMain';

const ROLE_PRIORITY = ['superadmin', 'admin', 'manager', 'designer', 'teacher', 'student'];

const AcademyLMSLayout = () => {
  const { roles, loading, activeRole } = usePermissions();
  const location = useLocation();
  React.useEffect(() => {}, []);

  console.log('[AcademyLMSLayout] Debug:', {
    loading,
    roles,
    rolesLength: roles?.length || 0,
    location: location.pathname,
    activeRole
  });

  if (loading) {
    console.log('AcademyLMSLayout: Still loading roles...');
    return <div>Loading...</div>;
  }

  // Parse role from URL path: /app/academy/lms/{role} or /academy/lms/{role}
  const match = location.pathname.match(/\/academy\/lms\/(superadmin|admin|manager|designer|teacher|student)/) ||
                location.pathname.match(/\/app\/academy\/lms\/(superadmin|admin|manager|designer|teacher|student)/);
  let routeRole = match ? match[1] : null;

  // Validate routeRole: must be in user's assigned roles or match activeRole
  let selectedRole = null;
  if (routeRole && roles.some(r => r.role === routeRole)) {
    selectedRole = routeRole;
  } else if (activeRole && roles.some(r => r.role === activeRole)) {
    selectedRole = activeRole;
  } else if (Array.isArray(roles) && roles.length > 0) {
    // Fallback: use highest priority role
    for (const r of ROLE_PRIORITY) {
      if (roles.some(roleObj => roleObj.role === r)) {
        selectedRole = r;
        break;
      }
    }
  }

  console.log('[AcademyLMSLayout] Selected role for layout:', { selectedRole, routeRole, activeRole, roles });

  if (!selectedRole) {
    console.log('AcademyLMSLayout: No valid role found, showing not authorized');
    return <div className="not-authorized">You are not authorized to access the Academy LMS.</div>;
  }

  // Check if at base LMS path (no child route)
  // Only render MainComponent for exact base paths, use Outlet for nested routes
  const isBaseLMS =
    location.pathname === '/app/academy/lms' ||
    location.pathname === '/academy/lms';

  console.log('AcademyLMSLayout: Path check:', {
    pathname: location.pathname,
    isBaseLMS
  });

  let Layout, MainComponent;
  switch (selectedRole) {
    case 'student':
      Layout = StudentLMSLayout;
      MainComponent = StudentLMSMain;
      break;
    case 'teacher':
      Layout = TeacherLMSLayout;
      MainComponent = TeacherLMSMain;
      break;
    case 'designer':
      Layout = DesignerLMSLayout;
      MainComponent = DesignerLMSMain;
      break;
    case 'manager':
      Layout = ManagerLMSLayout;
      MainComponent = ManagerLMSMain;
      break;
    case 'admin':
      Layout = AdminLMSLayout;
      MainComponent = AdminLMSMain;
      break;
    case 'superadmin':
      Layout = SuperAdminLMSLayout;
      MainComponent = SuperAdminLMSMain;
      break;
    default:
      return <div className="not-authorized">You are not authorized to access the Academy LMS.</div>;
  }

  console.log('AcademyLMSLayout: Components selected:', {
    Layout: Layout?.name || 'Unknown',
    MainComponent: MainComponent?.name || 'Unknown',
    willRenderMain: isBaseLMS
  });

  return (
    <Layout>
      {isBaseLMS ? <MainComponent /> : <Outlet />}
    </Layout>
  );
};

export default AcademyLMSLayout;
